import { render, staticRenderFns } from "./pgd-form-causas.vue?vue&type=template&id=9acddaf2"
import script from "./pgd-form-causas.vue?vue&type=script&lang=js"
export * from "./pgd-form-causas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports